import React, {useState} from "react";
import {useForm} from "react-hook-form";
import CouponFields from "./CouponFields";

export default function () {
  const {register, handleSubmit, reset, control, getValues, watch} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});

  const couponFields = <CouponFields {...{register, errors, control, getValues, watch, data}} />;

  return {
    setErrors,
    couponFields,
    handleSubmit,
    reset,
    setData,
  }
}